import styled from 'styled-components'
import { Button } from '@chakra-ui/react'

export const Inputas = styled.input`
  display: none;
`

export const Label = styled.label`
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  color: #555555;
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-size: 16px;
  font-weight: 500;
  padding: 10px 20px;
  transition: all 0.3s ease-in-out;
  min-width: 230px;
  overflow: hidden;

  &:hover {
    background-color: #f5f5f5;
    border: 1px solid #999999;
    color: #333333;
  }
`

export const Textas = styled.span`
  display: inline-block;
  margin-right: 10px;
`

export const ButtonStyled = styled(Button)`
  background-color: #4caf50;
  border: none;
  border-radius: 4px;
  color: #ffffff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  padding: 10px 20px;
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: #3e8e41;
  }
`

export const InputText = styled.input`
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  box-shadow: none;
  color: #333333;
  font-size: 16px;
  font-weight: 400;
  padding: 10px 15px;
  transition: all 0.3s ease-in-out;
  width: 100%;

  &:hover,
  &:focus {
    border-color: #4caf50;
    box-shadow: 0 0 4px rgba(76, 175, 80, 0.4);
    outline: none;
  }

  &::placeholder {
    color: #999999;
  }
`
